import api from '@shared/services/api';
import { t } from 'i18next';

export const schoolService = {
    getSchools: async ({ searchQuery, searchType, pageNumber = 0, pageSize = 10, sortBy = 'name', sortDir = 'asc', ...searchParams }) => {
        try {
            const params = {
                page: pageNumber,
                size: pageSize,
                sortBy: sortBy || 'name',
                sortOrder: sortDir,
            };

            // Handle multiple search parameters
            if (searchQuery && typeof searchQuery === 'object') {
                // Add each search parameter directly to params
                Object.entries(searchQuery).forEach(([key, value]) => {
                    if (value && value.trim()) {
                        params[key] = value.trim();
                    }
                });
            } else if (searchQuery && typeof searchQuery === 'string') {
                // Handle legacy string search query
                if (searchType) {
                    params[searchType] = searchQuery.trim();
                }
            }

            // Add any additional search parameters
            Object.entries(searchParams).forEach(([key, value]) => {
                if (value && value.trim()) {
                    params[key] = value.trim();
                }
            });

            const response = await api.get('/institutions', { params });

            const { _embedded, page } = response.data;
            if (!_embedded || !_embedded.hrEducationInstDTOList) {
                console.error('Invalid response - no content:');
                throw new Error(t('common.dataNotFound'));
            }

            return {
                content: _embedded.hrEducationInstDTOList,
                totalPages: page.totalPages,
                totalElements: page.totalElements,
                pageNumber: page.pageable?.pageNumber || pageNumber
            };
        } catch (error) {
            console.error('Error fetching schools:', error);
            throw error;
        }
    },
    getSchoolsReportData: async () => {
        try {
            const response = await api.get('/institutions/report');
            return response.data;
        } catch (error) {
            console.error('Error fetching schools report data:', error);
            throw error;
        }
    },

    createSchool: async (schoolData) => {
        const formattedData = {
            name: schoolData.name,
            shortName: schoolData.shortName,
            address1: schoolData.address1,
            address2: schoolData.address2,
            country: schoolData.country,
            postcode: schoolData.postcode,
            active: schoolData.active
        };
        try {
            const response = await api.post('/institutions', formattedData);
            return response.data;
        } catch (error) {
            console.error('Error creating school:', error);
            throw error;
        }
    },

    updateSchool: async (id, schoolData) => {
        const formattedData = {
            name: schoolData.name,
            shortName: schoolData.shortName,
            address1: schoolData.address1,
            address2: schoolData.address2,
            country: schoolData.country,
            postcode: schoolData.postcode,
            active: schoolData.active
        };
        try {
            const response = await api.put(`/institutions/${id}`, formattedData);
            return response.data;
        } catch (error) {
            console.error('Error updating school:', error);
            throw error;
        }
    },

    deleteSchool: async (id) => {
        try {
            const response = await api.delete(`/institutions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting school:', error);
            throw error;
        }
    },

    saveTranslation: async (translationData) => {
        try {
            const formattedData = {
                instId: translationData.instId,
                langCode: "en_GB",
                translatedName: translationData.translatedName,
                translatedShortName: translationData.translatedShortName,
                translatedAddress1: translationData.translatedAddress1,
                translatedAddress2: translationData.translatedAddress2
            };
            
            const response = await api.post('/institutions/translate', formattedData);
            return response.data;
        } catch (error) {
            console.error('Error saving translation:', error);
            throw error;
        }
    },

    getTranslation: async (id) => {
        try {
            const response = await api.get(`/institutions/translation/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching translation:', error);
            throw error;
        }
    }
}; 